import { axiosInstance, axiosInstanceForm } from "../../Utils/AxiosInstance";

/**
 * Purchase Orders API Service
 * Mock API calls for Purchase Orders management
 * Using dummy endpoints that follow the system pattern
 */

export const GetAllPurchaseOrdersApi = async (projectId) => {
  try {
    // No projectId = all projects for the business.
    const query = projectId ? `?projectId=${projectId}` : "";
    const response = await axiosInstance.get(`/PurchaseOrders/GetAll${query}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const GetAllGrnApi = async (projectId) => {
  try {
    const query = projectId ? `?projectId=${projectId}` : "";
    const response = await axiosInstance.get(`/PurchaseOrders/GRN/GetAll${query}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddPurchaseOrderApi = async (data) => {
  try {
    const response = await axiosInstanceForm.post(`/PurchaseOrders/Create`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdatePurchaseOrderApi = async (data, id) => {
  try {
    const response = await axiosInstanceForm.put(`/PurchaseOrders/Edit/${id}`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const DeletePurchaseOrderApi = async (id) => {
  try {
    const response = await axiosInstance.delete(`/PurchaseOrders/Delete/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const GetPurchaseOrderByIdApi = async (id) => {
  try {
    const response = await axiosInstance.get(`/PurchaseOrders/GetById/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdateApprovalApi = async (approvalId, status, comments) => {
  try {
    const url = `/PurchaseOrders/UpdateApproval/${approvalId}?status=${encodeURIComponent(status)}&comments=${encodeURIComponent(comments || "")}`;
    const response = await axiosInstance.put(url);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const CreateGrnApi = async (payload) => {
  try {
    const response = await axiosInstanceForm.post(`/PurchaseOrders/CreateGRN`, payload);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdateGrnApprovalApi = async (approvalId, status, comments) => {
  try {
    const url = `/PurchaseOrders/UpdateGrnApproval/${approvalId}?status=${encodeURIComponent(status)}&comments=${encodeURIComponent(comments || "")}`;
    const response = await axiosInstance.put(url);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};
